// extracted by mini-css-extract-plugin
module.exports = {"container":"FreeText_container__2NqiT","questionWrapper":"FreeText_questionWrapper__1kvuV","answerWrapper":"FreeText_answerWrapper__1esY3"};